import React from "react";

const Footer = () => {
  return (
    <div>
      <p style={{ color: "white", textAlign: "center" }}>
        All right reserve 2023 &copy;{" "}
      </p>
    </div>
  );
};

export default Footer;
